import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TreeNode } from '@equipmyschool/emsadminweb-models';

@Component({
  selector: 'app-orderline-tree-node',
  templateUrl: './orderline-tree-node.component.html',
  styleUrls: ['./orderline-tree-node.component.scss']
})
export class OrderlineTreeNodeComponent implements OnInit {
  @Input() node!: TreeNode;
  @Input() states!: Map<TreeNode, number>;
  @Input() autoExpand = false;
  @Output() nodeToggle = new EventEmitter<any>();
  @Output() nodeSelected = new EventEmitter<TreeNode>();

  expanded = false;

  ngOnInit() {
    this.expanded = this.autoExpand;
  }

  selectNode(n: TreeNode) {
    this.nodeSelected.emit(n);
  }

  onToggle(n:any){ this.nodeToggle.emit(n) }

  toggleExpand(ev?: Event){ if (ev) ev.stopPropagation(); this.expanded = !this.expanded }

  isExpanded(){ return this.expanded }
}
